<h1 mat-dialog-title>{{ data.dialogTitle }}</h1>
<div mat-dialog-content>
  <form class="edit-subscription-level-dialog-form">
    <mat-form-field *ngIf="data.isNew">
      <mat-label>Subscription Type</mat-label>
      <mat-select
        name="data.subscriptionTypeId"
        [(ngModel)]="data.subscriptionTypeId"
      >
        <mat-option
          *ngFor="let subTypes of data.interactSubTypes"
          [value]="subTypes.interactSubTypeId"
          >{{ subTypes.interactSubTypeName }}</mat-option
        >
      </mat-select>
    </mat-form-field>
    <ng-conainer *ngIf="!data.isNew">
      <mat-label>Subscription Type</mat-label>
      <div>
        <ng-container *ngFor="let subTypes of data.interactSubTypes">
          <ng-container
            *ngIf="subTypes.interactSubTypeId == data.subscriptionTypeId"
          >
            {{ subTypes.interactSubTypeName }}
          </ng-container>
        </ng-container>
      </div>
    </ng-conainer>
    <br />
    <mat-form-field>
      <mat-label>Description</mat-label>
      <input
        matInput
        name="data.description"
        [(ngModel)]="data.description"
      /> </mat-form-field
    ><br />
    <mat-form-field>
      <mat-label>Max Admin Users</mat-label>
      <input
        matInput
        name="data.maxAdminUsers"
        [(ngModel)]="data.maxAdminUsers"
      /> </mat-form-field
    ><br />
    <mat-form-field>
      <mat-label>Max Designer Users</mat-label>
      <input
        matInput
        name="data.maxDesignerUsers"
        [(ngModel)]="data.maxDesignerUsers"
      /> </mat-form-field
    ><br />
    <mat-form-field>
      <mat-label>Max Dashboard Users</mat-label>
      <input
        matInput
        name="data.maxDashboardUsers"
        [(ngModel)]="data.maxDashboardUsers"
      /> </mat-form-field
    ><br />
    <mat-form-field>
      <mat-label>Max Report Users</mat-label>
      <input
        matInput
        name="data.maxReportUsers"
        [(ngModel)]="data.maxReportUsers"
      /> </mat-form-field
    ><br />
    <ng-container>
      <mat-checkbox name="data.allowPrintOnDemand" [(ngModel)]="data.allowPrintOnDemand"
      >Allow Print On Demand?</mat-checkbox
      > </ng-container
    ><br />
    <ng-container>
      <mat-checkbox name="data.allowDataOnDemand" [(ngModel)]="data.allowDataOnDemand"
      >Allow Data On Demand?</mat-checkbox
      > </ng-container
    ><br />
    <ng-container>
      <mat-checkbox name="data.hasApiAccess" [(ngModel)]="data.hasApiAccess"
        >Has API Access?</mat-checkbox
      > </ng-container
    ><br />
     <ng-container *ngIf="data.hasApiAccess || data.allowDataOnDemand">
       <!--<ng-container>
         <mat-checkbox name="data.unlimitedDataSetData" [(ngModel)]="data.unlimitedDataSetData">Unlimited Data Set Access?</mat-checkbox>
       </ng-container>
       <br />
       <mat-form-field *ngIf="!data.unlimitedDataSetData">
         <mat-label>Monthly Data Set Rows</mat-label>
         <input matInput
                name="data.monthlyDataSetDataRows"
                [(ngModel)]="data.monthlyDataSetDataRows" />
       </mat-form-field>
       <br *ngIf="!data.unlimitedDataSetData" />-->
       <ng-container>
         <mat-checkbox name="data.unlimitedSourceData" [(ngModel)]="data.unlimitedSourceData">Unlimited Data Rows?</mat-checkbox>
       </ng-container>
       <br />
       <mat-form-field *ngIf="!data.unlimitedSourceData">
         <mat-label>Monthly Data Rows</mat-label>
         <input matInput
                name="data.monthlySourceDataRows"
                [(ngModel)]="data.monthlySourceDataRows" />
       </mat-form-field>
       <br *ngIf="!data.unlimitedSourceData" />
     </ng-container>
    <ng-container>
      <mat-checkbox name="data.allowDownload" [(ngModel)]="data.allowDownload"
        >Allow Download?</mat-checkbox
      > </ng-container
    ><br />
    <ng-container>
      <mat-checkbox name="data.allowPurchase" [(ngModel)]="data.allowPurchase"
        >Allow Purchase?</mat-checkbox
      > </ng-container
    ><br />
    <ng-container>
      <mat-checkbox name="data.allowModify" [(ngModel)]="data.allowModify"
        >Allow Modify?</mat-checkbox
      > </ng-container
    ><br />
    <ng-container>
      <mat-checkbox name="data.allowPreFilter" [(ngModel)]="data.allowPreFilter"
      >Allow Pre-Filtering?</mat-checkbox
      > </ng-container
    ><br />
    <ng-container>
      <mat-checkbox name="data.allowInvoice" [(ngModel)]="data.allowInvoice"
        >Allow Invoice?</mat-checkbox
      > </ng-container
    ><br />
  </form>
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="onConfirmClick()">
    Save Subscription Level
  </button>
  <button mat-raised-button (click)="onCancelClick()">Cancel</button>
</div>
